import { render, staticRenderFns } from "./ex1.vue?vue&type=template&id=0a8dd04f&scoped=true&"
import script from "./ex1.vue?vue&type=script&lang=js&"
export * from "./ex1.vue?vue&type=script&lang=js&"
import style0 from "./ex1.vue?vue&type=style&index=0&id=0a8dd04f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8dd04f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a8dd04f')) {
      api.createRecord('0a8dd04f', component.options)
    } else {
      api.reload('0a8dd04f', component.options)
    }
    module.hot.accept("./ex1.vue?vue&type=template&id=0a8dd04f&scoped=true&", function () {
      api.rerender('0a8dd04f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/applyManage/gdApply/ex1.vue"
export default component.exports